/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import type { GrowthRecommendationModalEntrypointProps } from './ui/GrowthRecommendationModal.entrypoint.types.tsx';

type GrowthRecommendationsEntrypointComponent = EntryPointComponent<
	{},
	{},
	GrowthRecommendationModalEntrypointProps,
	{}
>;

export const GrowthRecommendationsEntrypoint: EntryPoint<
	GrowthRecommendationsEntrypointComponent,
	{}
> = createEntryPoint({
	root: JSResourceForInteraction<GrowthRecommendationsEntrypointComponent>(
		/* webpackChunkName: "async-jira-navigation-apps-sidebar-nav4-growth-recommendations" */ './ui/GrowthRecommendationModal.tsx',
	),
	getPreloadProps: (props) => ({
		queries: {}, // Need to specify `queries` as it is a mandatory prop
		props,
	}),
});
